import {
	addDoc,
	collection,
	getDocs,
	orderBy,
	query,
	where,
} from "firebase/firestore";
import { db } from "../firebase";
import type { SummaryRecord } from "../types/analyzer";

export const fetchSummaries = async (uid: string): Promise<SummaryRecord[]> => {
	const summariesQuery = query(
		collection(db, "summaries"),
		where("uid", "==", uid),
		orderBy("timestamp", "desc")
	);
	const docs = await getDocs(summariesQuery);
	return docs.docs.map((doc) => doc.data() as SummaryRecord);
};

export const createSummary = async (summary: SummaryRecord): Promise<void> => {
	await addDoc(collection(db, "summaries"), summary);
};